/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_5Inputs */

const en_us2_onboarding_parq_5 = /** @type {(inputs: Onboarding_Parq_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you have a bone or joint problem that could be made worse by physical activity?`)
};

const pt_br2_onboarding_parq_5 = /** @type {(inputs: Onboarding_Parq_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você tem algum problema ósseo ou articular que poderia piorar com a atividade física?`)
};

const es_419_onboarding_parq_5 = /** @type {(inputs: Onboarding_Parq_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes algún problema en los huesos o las articulaciones que podría empeorar con la actividad física?`)
};

const pt_pt2_onboarding_parq_5 = /** @type {(inputs: Onboarding_Parq_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tens algum problema ósseo ou articular que possa piorar com a atividade física?`)
};

const fr_fr2_onboarding_parq_5 = /** @type {(inputs: Onboarding_Parq_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As-tu un problème osseux ou articulaire qui pourrait s'aggraver avec l'activité physique ?`)
};

const de_de2_onboarding_parq_5 = /** @type {(inputs: Onboarding_Parq_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hast du ein Knochen- oder Gelenkproblem, das durch körperliche Aktivität schlimmer werden könnte?`)
};

const it_it2_onboarding_parq_5 = /** @type {(inputs: Onboarding_Parq_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai un problema alle ossa o alle articolazioni che potrebbe peggiorare con l'attività fisica?`)
};

/**
* | output |
* | --- |
* | "Do you have a bone or joint problem that could be made worse by physical activity?" |
*
* @param {Onboarding_Parq_5Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_5 = /** @type {((inputs?: Onboarding_Parq_5Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_5Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_5(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_5(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_5(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_5(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_5(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_5(inputs)
	return en_us2_onboarding_parq_5(inputs)
});
export { onboarding_parq_5 as "onboarding.parq.5" }